import React from 'react';
import { UserIcon, HeartPulseIcon, PhoneIcon, RocketIcon } from 'lucide-react';
export function UseCases() {
  return <section id="use-cases" className="w-full py-20 px-6 md:px-10 lg:px-20 bg-[#111]" data-id="element-185">
      <div className="max-w-6xl mx-auto" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF] mb-3" data-id="element-188">
            How You Can Use It
          </h2>
          <p className="text-3xl md:text-4xl font-bold" data-id="element-189">
            Versatile Applications for Any Industry
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-190">
          {/* Use Case 1 */}
          <div className="p-6 rounded-xl bg-[#222] border border-gray-800 hover:border-[#00E0FF]/30 transition-all group" data-id="element-191">
            <div className="w-12 h-12 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-4 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-192">
              <div className="w-6 h-6 text-[#00E0FF]" data-id="element-193" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-194">
              Critical Voice Infrastructure
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-195">
              Plug our API into your web or mobile app — instantly add
              world-class conversational voice to anything.
            </p>
            <ul className="space-y-2" data-id="element-196">
              <li className="flex items-center text-sm" data-id="element-197">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-198"></span>
                Ultra-low latency
              </li>
              <li className="flex items-center text-sm" data-id="element-199">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-200"></span>
                Emotionally expressive
              </li>
              <li className="flex items-center text-sm" data-id="element-201">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-202"></span>
                Custom prompts & personas
              </li>
              <li className="flex items-center text-sm" data-id="element-203">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-204"></span>
                White-label ready
              </li>
            </ul>
          </div>
          {/* Use Case 2 */}
          <div className="p-6 rounded-xl bg-[#222] border border-gray-800 hover:border-[#00E0FF]/30 transition-all group" data-id="element-205">
            <div className="w-12 h-12 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-4 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-206">
              <UserIcon className="w-6 h-6 text-[#00E0FF]" data-id="element-207" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-208">Voice Rep</h3>
            <p className="text-gray-300 mb-4" data-id="element-209">
              Why make users type when they can just talk? The first AI rep that
              actually converts.
            </p>
            <ul className="space-y-2" data-id="element-210">
              <li className="flex items-center text-sm" data-id="element-211">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-212"></span>
                Embed a pop-up voice rep on your website
              </li>
              <li className="flex items-center text-sm" data-id="element-213">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-214"></span>
                Greet users, answer questions, qualify leads
              </li>
              <li className="flex items-center text-sm" data-id="element-215">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-216"></span>
                Book meetings automatically
              </li>
              <li className="flex items-center text-sm" data-id="element-217">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-218"></span>
                24/7, no typos, no menus — just conversation
              </li>
            </ul>
          </div>
          {/* Use Case 3 */}
          <div className="p-6 rounded-xl bg-[#222] border border-gray-800 hover:border-[#00E0FF]/30 transition-all group" data-id="element-219">
            <div className="w-12 h-12 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-4 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-220">
              <HeartPulseIcon className="w-6 h-6 text-[#00E0FF]" data-id="element-221" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-222">AI Therapist</h3>
            <p className="text-gray-300 mb-4" data-id="element-223">
              Deploy as a hyper-realistic voice therapist for clinics, wellness
              platforms, or health systems.
            </p>
            <ul className="space-y-2" data-id="element-224">
              <li className="flex items-center text-sm" data-id="element-225">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-226"></span>
                Always-on listener
              </li>
              <li className="flex items-center text-sm" data-id="element-227">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-228"></span>
                Emotionally calibrated tone
              </li>
              <li className="flex items-center text-sm" data-id="element-229">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-230"></span>
                Session summaries + parent alerts
              </li>
              <li className="flex items-center text-sm" data-id="element-231">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-232"></span>
                You'll forget it's AI — and that's the point
              </li>
            </ul>
          </div>
          {/* Use Case 4 */}
          <div className="p-6 rounded-xl bg-[#222] border border-gray-800 hover:border-[#00E0FF]/30 transition-all group" data-id="element-233">
            <div className="w-12 h-12 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-4 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-234">
              <PhoneIcon className="w-6 h-6 text-[#00E0FF]" data-id="element-235" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-236">AI Receptionist</h3>
            <p className="text-gray-300 mb-4" data-id="element-237">
              Let AI answer your business calls or web inquiries with
              professionalism and warmth.
            </p>
            <ul className="space-y-2" data-id="element-238">
              <li className="flex items-center text-sm" data-id="element-239">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-240"></span>
                Captures caller info
              </li>
              <li className="flex items-center text-sm" data-id="element-241">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-242"></span>
                Answers FAQs
              </li>
              <li className="flex items-center text-sm" data-id="element-243">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-244"></span>
                Sends email follow-ups
              </li>
              <li className="flex items-center text-sm" data-id="element-245">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-246"></span>
                Can route, schedule, or qualify
              </li>
            </ul>
          </div>
          {/* Use Case 5 */}
          <div className="p-6 rounded-xl bg-[#222] border border-gray-800 hover:border-[#00E0FF]/30 transition-all group md:col-span-2 lg:col-span-1" data-id="element-247">
            <div className="w-12 h-12 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-4 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-248">
              <RocketIcon className="w-6 h-6 text-[#00E0FF]" data-id="element-249" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-250">Custom Use Cases</h3>
            <p className="text-gray-300 mb-4" data-id="element-251">
              Our clients are using Critical Voice for innovative applications
              across industries.
            </p>
            <ul className="space-y-2" data-id="element-252">
              <li className="flex items-center text-sm" data-id="element-253">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-254"></span>
                AI Tour Guides in physical locations
              </li>
              <li className="flex items-center text-sm" data-id="element-255">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-256"></span>
                AI Operations Manager for construction teams
              </li>
              <li className="flex items-center text-sm" data-id="element-257">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-258"></span>
                AI Sales Trainer coaching reps during live calls
              </li>
              <li className="flex items-center text-sm" data-id="element-259">
                <span className="w-2 h-2 rounded-full bg-[#00E0FF] mr-2" data-id="element-260"></span>
                And many more custom implementations
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}